<template>
  <scrollactive
     v-on:itemchanged="onItemChanged"
  >
    <div style="padding-right:10px;">
      <div>
        <span
          style="font-size: 14px; float:left;"
        >
          <span v-if="pendingSaves > 0">
            <v-icon class="spin">sync</v-icon> <small>Saving {{ pendingSaves }} requests...</small>
          </span>
          <span v-else>
            <v-icon>save</v-icon> <small>Saved</small>
          </span>
        </span>
        <span
          v-if="totalAnswersFU"
          style="text-align:right;margin-top:5px;float:right;"
        >
          <b>{{totalAnswersFU}}</b> needing follow up
        </span>
      </div>
      <br />
      <br />
      <div
        v-for="section in sectionHeads"
        :key="section.id"
        style="text-indent: -42px;padding-left:40px;"
      >
        <a
          :href="sectionElSelector(section)"
          class="scrollactive-item"
        >
          <span v-if="section.number">{{ section.number }}.</span>
          {{ section.text }}
          <b
            v-if="sectionAnswersFU(section.id)"
            style="float:right;text-align:right;"
          >
            <span>({{sectionAnswersFU(section.id)}})</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-icon small>report_problem</v-icon>
          </b>
        </a>
      </div>
    </div>
    <v-fade-transition>
      <div
        v-if="details"
        style="color:#546E7A;padding-top:20px;overflow:hidden;"
      >
        <b>{{ userform.name }}</b><br />
        <span
          style="text-transform: capitalize;"
        >
          <b>Status:&nbsp;</b>{{ userform.status }}
        </span><br />
        <span v-if="userform.party_name"><b>Party Name:</b> {{userform.party_name}}<br /></span>
        <span v-if="userform.form_number"><b>Form #:</b> {{userform.form_number}}<br /></span>
        <span v-if="userform.tags" style="max-width: 95%;">
          <b>Tags:</b>&nbsp;
          <span
            v-for="tag in userform.tags"
            :key="tag"
            class="inline-tag"
          >
            {{tag}}
          </span>
          <br />
        </span>
      </div>
    </v-fade-transition>
  </scrollactive>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UserFormNavigator',
  props: [ 'userform', 'details' ],
  methods: {
    sectionElSelector (section) {
      return `#section-${section.id}`
    },
    onItemChanged(event, currentItem) {
      try {
        history.replaceState(null, null, '#' + currentItem.href.split('#')[1])
      } catch (e) {
        // do nothing
      }
    }
  },
  computed: {
    ...mapGetters('userform', [
      'totalAnswersFU',
      'sectionAnswersFU',
      'pendingSaves'
    ]),
    sectionHeads () {
      return this.userform.sections.filter(section => section.part_type === "s")
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: grey;
  margin:5px;
  padding-left: 16px;
  line-height: 25px;
}

a:hover {
  text-decoration: underline;
}

a.is-active {
  color:#2196f3!important;
  position:relative;
  border-left: solid #2196f3 2px;
}

.inline-tag {
  display:inline-block;
  font-weight: bold;
  background-color:lightgrey;
  color:white;
  border-radius:3px;
  padding:3px 4px 2px 4px;
  text-align:center;
  margin-right:5px;
  line-height:12px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: inherit;
}
</style>
